import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { clearField, DoubleDateTableFilter, DoubleNumberInputTableFilter, getError, SmartFormContainer } from '@shared';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-double-number-input-filter',
  templateUrl: './double-number-input-filter.component.html',
  styleUrls: ['./double-number-input-filter.component.scss'],
})
export class DoubleNumberInputFilterComponent extends SmartFormContainer implements OnInit {
  readonly getError = getError;
  readonly clearField = clearField;
  @Input() config: DoubleNumberInputTableFilter;
  @Input() sm: boolean = false;

  get control(): FormControl {
    return this.form.get(this.controlName) as FormControl;
  }

  override ngOnInit(): void {
    // We don't need this because we don't want to
    // get such control { '': null }
    void 0;
  }
}
